import { apolloClient } from '@services/apollo'
import {
  DeleteFileDocument,
  DeleteFileMutationFn,
  DeleteFileMutationVariables,
  FileDataFragment,
  FileDataFragmentDoc,
  ReplaceFileInOrderDocument,
  ReplaceFileInOrderMutationFn,
  UpdateContentMutationFn,
  UpdateFileDocument,
  UpdateFileMutationFn,
  UpdateFileMutationVariables,
  UploadFileDocument,
  UploadFileMutation,
  UploadFileMutationFn,
  UploadFileMutationVariables
} from '@typings/graphql'

export type ContentFile = FileDataFragment

export const isGraphQlFile = (file: ContentFile | File | undefined | null): file is ContentFile => {
  return !!(file as ContentFile)?.id
}

export const uploadFile = async (variables: UploadFileMutationVariables) => {
  return new Promise((resolve, reject) => {
    apolloClient.mutate<UploadFileMutation, UploadFileMutationVariables>({
      mutation: UploadFileDocument,
      variables,
      update: (cache, { data }) => {
        console.log('uploadFile', data)

        if (data?.uploadFile) {
          cache.writeFragment({
            id: cache.identify(data.uploadFile),
            fragment: FileDataFragmentDoc,
            fragmentName: 'FileData',
            data: data.uploadFile
          })
        }

        if (!data?.uploadFile && variables.data.replaceId) {
          cache.evict({
            id: cache.identify({ __typename: 'File', id: variables.data.replaceId })
          })
        }
      }
    }).then(resolve).catch(reject)
  })
}

export const updateFile = async (variables: UpdateFileMutationVariables) => {
  return new Promise((resolve, reject) => {
    apolloClient.mutate<UpdateFileMutationFn, UpdateFileMutationVariables>({
      mutation: UpdateFileDocument,
      variables
    }).then(resolve).catch(reject)
  })
}

export const uploadContentFiles = async (variables: UploadFileMutationVariables[]) => {
  const imageUploads = variables.map((vars) => (
    new Promise((resolve, reject) => {
      apolloClient.mutate<UploadFileMutationFn, UploadFileMutationVariables>({
        mutation: UploadFileDocument,
        variables: vars
      }).then(resolve).catch(reject)
    })
  ))

  return await Promise.all(imageUploads).then((values) => values).catch((e) => e)
}

export const replaceContentFiles = async (variables: UploadFileMutationVariables[]) => {
  const imageUploads = variables.map((vars) => (
    new Promise((resolve, reject) => {
      apolloClient.mutate<ReplaceFileInOrderMutationFn, UploadFileMutationVariables>({
        mutation: ReplaceFileInOrderDocument,
        variables: vars
      }).then(resolve).catch(reject)
    })
  ))

  return await Promise.all(imageUploads).then((values) => values).catch((e) => e)
}

export const updateContentFiles = async (variables: UpdateFileMutationVariables[]) => {
  const deleteImages = variables.map((vars) => (
    new Promise((resolve, reject) => {
      apolloClient.mutate<UpdateContentMutationFn, UpdateFileMutationVariables>({
        mutation: UpdateFileDocument,
        variables: vars
      }).then(resolve).catch(reject)
    })
  ))

  return await Promise.all(deleteImages).then((values) => values).catch((e) => e)
}

export const deleteContentFiles = async (variables: DeleteFileMutationVariables[]) => {
  const deleteImages = variables.map((vars) => (
    new Promise((resolve, reject) => {
      apolloClient.mutate<DeleteFileMutationFn, DeleteFileMutationVariables>({
        mutation: DeleteFileDocument,
        variables: vars
      }).then(resolve).catch(reject)
    })
  ))

  return await Promise.all(deleteImages).then((values) => values).catch((e) => e)
}
